import { api } from '../configs/apiConfig';

const messageCategoryService = {
    getAll: async () => {
        try {
            console.log('Making API call to get categories...');
            const response = await api.get('/MessageCategories');
            console.log('API response:', response);
            return response.data;
        } catch (error) {
            console.error('Error fetching message categories:', error);
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const response = await api.get(`/MessageCategories/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching message category ${id}:`, error);
            throw error;
        }
    },

    create: async (category) => {
        try {
            const response = await api.post('/MessageCategories', category);
            return response.data;
        } catch (error) {
            console.error('Error creating message category:', error);
            throw error;
        }
    },

    update: async (id, category) => {
        try {
            const response = await api.put(`/MessageCategories/${id}`, category);
            return response.data;
        } catch (error) {
            console.error(`Error updating message category ${id}:`, error);
            throw error;
        }
    },

    delete: async (id) => {
        try {
            await api.delete(`/MessageCategories/${id}`);
            return true;
        } catch (error) {
            console.error(`Error deleting message category ${id}:`, error);
            throw error;
        }
    },

    // Helper method to format category data
    formatCategoryData: (category) => {
        return {
            id: category.id,
            name: category.name,
            description: category.description,
            defaultRecipientIds: category.defaultRecipientIds || []
        };
    }
};

export default messageCategoryService; 